import { validation } from "../shared/constants";
import { Person } from "./Person";

export interface ICustomer {
    [key: string]: any;

    readonly key: string;
    name: string;
    email: string;
    id?: string;
    readonly isNew: boolean;

    validateCustomer: (isCorporateMeeting: boolean) => { isValid: boolean; invalidFields: string[] };
    validateName: () => boolean;
    validateEmail: () => boolean;
    validateId: () => boolean;
}

export class Customer extends Person implements ICustomer {
    id?: string;

    private constructor(name: string, email: string, id?: string, isNew?: boolean) {
        super(name, email, isNew);
        this.id = id;
    }

    static New(): Customer {
        return new Customer("", "", undefined, true);
    }

    static Existing(name: string, email: string, id?: string): Customer {
        return new Customer(name, email, id, false);
    }

    validateCustomer(isCorporateMeeting: boolean): { isValid: boolean; invalidFields: string[] } {
        const invalidFields = [];

        if (!this.validateName()) {
            invalidFields.push("name");
        }

        if (!this.validateEmail()) {
            invalidFields.push("email");
        }

        if (!isCorporateMeeting && !this.validateId()) {
            invalidFields.push("id");
        }

        return { isValid: invalidFields.length === 0, invalidFields: invalidFields };
    }

    validateId(): boolean {
        return !this.id || this.id.length === 0 || !!this.id.match(validation.clientIdRegExp);
    }
}
